import React from 'react';
import { Line } from 'react-chartjs-2';
import { NoGraphDataSvg, LoadingIndicatorSvg } from 'components/icons';
import { getInspectionsLabels, getIsMobile } from 'utils';

const isMobile = getIsMobile();

const calculateYAxis = (maxDataValue) => {
  let step = 5;
  while (step * 4 < maxDataValue) {
    step += step % 10 === 0 ? 10 : 5;
  }

  const maxY = step * 4;
  return { maxY, step };
}

export const CustomChart = (props) => {
  const { completedInspectionsGraphData, openInspectionsGraphData, selectedDate, onElementClick, loading } = props;
  let maxCount = Math.max(...completedInspectionsGraphData, ...openInspectionsGraphData);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
        type: 'linear',
        gridLines: {
          drawTicks: false,
        },
        ticks: {
          fontColor: "#A2A3A5",
          min: 0,
          stepSize: calculateYAxis(maxCount).step,
          suggestedMax: calculateYAxis(maxCount).maxY,
          padding: 10
        }
      }],
      xAxes: [{
        gridLines: {
          display: false,
        },
        ticks: {
          fontColor: "#A2A3A5",
        }
      }]
    },
    legend: {
      display: false,
    },
    onClick: function (evt, element) {
      onElementClick(element[0]?._index ?? -1)
    },

    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    tooltips: {
      titleFontSize: 12,
      mode: 'nearest',
      intersect: false,
      xAlign: 'center',
      yAlgn: 'top',
      axis: 'x',
      xPadding: 10,
      callbacks: {
        title: () => {
          return `Inspections`
        },
        label: ({ datasetIndex, value }) => {
          return `${value} ${datasetIndex === 0 ? 'completed' : 'open'} inspections`
        }
      }
    },
  };

  const chart = (canvas) => {

    const ctx = canvas?.getContext("2d");
    const gradient = ctx?.createLinearGradient(0, 0, 0, canvas.height);
    gradient?.addColorStop(0, `#1DBD6B`);
    gradient?.addColorStop(1, `#1DBD6B00`);

    return {
      labels: getInspectionsLabels(selectedDate),
      datasets: [
        {
          label: 'completed',
          data: loading ? [] : completedInspectionsGraphData,
          backgroundColor: gradient,
          borderColor: `#1DBD6B`,
          pointHoverRadius: 8,
          pointBackgroundColor: `#1DBD6B`,
          pointHoverBorderColor: '#FFFFFF',
          pointHoverBorderWidth: 4,
        },
        {
          label: 'open',
          data: loading ? [] : openInspectionsGraphData,
          borderColor: `#FFC700`,
          pointHoverRadius: 8,
          pointBackgroundColor: `#FFC700`,
          pointHoverBorderColor: '#FFFFFF',
          pointHoverBorderWidth: 4,
          fill: false,
        },
      ]
    }
  }

  return (
    <div className="w-full relative flex" style={{ height: isMobile ? 240 : 340 }}>
      <div className='w-full h-full'>
        <Line data={chart} height={'90%'} options={options} />
      </div>
      {openInspectionsGraphData.length === 0 && completedInspectionsGraphData.length === 0 && !loading &&
        <div className='absolute flex left-0 right-0 top-0 bottom-0 items-center justify-center'>
          <NoGraphDataSvg inspectionsAnalytics />
        </div>
      }
      {loading &&
        <div className='absolute flex left-0 right-0 top-0 bottom-0 items-center justify-center'>
          <LoadingIndicatorSvg />
        </div>
      }
    </div >
  )
}
